import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const ScoreModal = ({ isOpen, onClose, presentationId, authToken }) => {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [presentationTitle, setPresentationTitle] = useState(""); // ✅ State for presentation title

  useEffect(() => {
    if (!presentationId) return;

    const fetchScores = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `https://doshfebackend.teemah.com.ng/api/auth/scoreboard/presentation/?presentation_id=${presentationId}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setScores(response.data);

        // ✅ Fetch and display the presentation title from the first entry
        if (response.data.length > 0) {
          setPresentationTitle(response.data[0].presentation_title); // Make sure this key matches your API response
        } else {
          setPresentationTitle("Unknown Presentation");
        }
      } catch (err) {
        setError("Failed to fetch scores. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchScores();
  }, [presentationId, authToken]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-2xl p-6 rounded-lg shadow-lg relative">
        {/* ✅ Close Button inside the modal */}
        <div className="flex justify-between items-center border-b pb-2 mb-4">
          <h2 className="text-lg font-semibold text-blue-600">Scoreboard</h2>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
          >
            Close
          </button>
        </div>

        {/* ✅ Display Presentation Title */}
        <h2 className="text-xl font-bold text-blue-600 mb-4">
          {loading ? "Loading Presentation..." : presentationTitle}
        </h2>

        {loading ? (
          <p className="text-gray-600">Loading scores...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : scores.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300 shadow-md">
              <thead>
                <tr className="bg-blue-600 text-white">
                  <th className="border p-3">S/N</th>
                  <th className="border p-3">Type</th>
                  <th className="border p-3">Score</th>
                  <th className="border p-3">Total Marks</th>
                  <th className="border p-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {scores.map((score, index) => (
                  <tr key={score.id} className="border hover:bg-blue-100">
                    <td className="border p-3">{index + 1}</td>
                    <td className="border p-3">{score.presentation_type}</td>
                    <td className="border p-3 font-semibold bg-yellow-100">
                      {score.score}
                    </td>
                    <td className="border p-3">{score.total_marks}</td>
                    <td className="border p-3">
                      {new Date(score.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-600">No scores available for this presentation.</p>
        )}
      </div>
    </div>
  );
};

export default ScoreModal;
